module.exports = __webpack_public_path__ + "img/camera.7eb5ea8d.png";